export const ANALYTICS = {
  google: {
    measurementId: 'G-Z1YPSLR2LR',
  },
} as const;
